import { type NotificationItem } from '@/lib/queries/notification/v1/history/types'

import aosEligibleIcon from './ui/icons/aos-eligible-icon.svg'
import caseInquiryEligibleIcon from './ui/icons/case-inquiry-eligible-icon.svg'
import alertNotificationIcon from './ui/icons/other-alert-notification-icon.svg'
import statusUpdateIcon from './ui/icons/status-message-update-icon.svg'
import statusUpdateEoirIcon from './ui/icons/status-update-eoir-icon.svg'
import visaBulletinUpdateIcon from './ui/icons/visa-bulletin-update-icon.svg'

/**
 * Gets the icon and title for the given message type
 * @param messageType The message type to get the icon and title for
 * @returns The icon and title for the given message type
 */
export const getMessageIconAndTitle = (
  messageType: NotificationItem['messageType']
): { icon: string; title: string } => {
  switch (messageType) {
    case 'CASE_STATUS':
      return {
        icon: statusUpdateIcon,
        title: 'Status Message Update',
      }
    case 'INQUIRY_ELIGIBLE':
      return {
        icon: caseInquiryEligibleIcon,
        title: 'Case Inquiry Eligible',
      }
    case 'AOS_ELIGIBLE':
      return {
        icon: aosEligibleIcon,
        title: 'AOS Eligible',
      }
    case 'EOIR_CASE_STATUS':
      return {
        icon: statusUpdateEoirIcon,
        title: 'Status Update',
      }
    case 'ALERT':
      return {
        icon: alertNotificationIcon,
        title: 'Other Alert Notification',
      }
    case 'BULLETIN':
      return {
        icon: visaBulletinUpdateIcon,
        title: 'Visa Bulletin',
      }
    default:
      return {
        icon: '',
        title: '',
      }
  }
}
